import { useState, useEffect } from 'react';

const useChatLimit = (maxChats = 50) => {
  const [chatCount, setChatCount] = useState(0);
  const [isLimited, setIsLimited] = useState(false);
  
  useEffect(() => {
    const lastResetDate = localStorage.getItem('lastResetDate');
    const today = new Date().toDateString();
    
    if (lastResetDate !== today) {
      localStorage.setItem('lastResetDate', today);
      localStorage.setItem('chatCount', '0');
      setChatCount(0);
      setIsLimited(false);
    } else {
      const storedCount = parseInt(localStorage.getItem('chatCount') || '0');
      setChatCount(storedCount);
      setIsLimited(storedCount >= maxChats);
    }
  }, [maxChats]);
  
  const incrementCount = () => {
    if (chatCount >= maxChats) {
      setIsLimited(true);
      return false;
    }
    
    const newCount = chatCount + 1;
    setChatCount(newCount);
    localStorage.setItem('chatCount', newCount.toString());
    
    if (newCount >= maxChats) {
      setIsLimited(true);
    }
    
    return true;
  };

  return {
    isLimited,
    chatCount,
    incrementCount,
    maxChats
  };
};

export { useChatLimit };